import { OrganizationConfig } from '@tenants/types/tenant';
import { EXP_CANADA_ADDRESS } from '@tenants/definitions/shared/addresses';

export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber() {
      return '833-303-0610';
    },
    email() {
      return 'info@exprealty.net';
    },
    address() {
      return EXP_CANADA_ADDRESS;
    },
    twitterUrl: 'https://twitter.com/exprealtycanada',
    facebookUrl: 'https://www.facebook.com/exprealtycanada',
    instagramUrl: 'https://www.instagram.com/expcanada_?igsh=YmtqZzRqZHR1Z2Yw&utm_source=qr',
    linkedinUrl: 'https://www.linkedin.com/showcase/exprealtycanada',
    youtubeUrl: 'https://www.youtube.com/@eXpRealty',
    joinSectionUrl: 'https://join.exprealty.ca',
  };
}
